export default {
  name: 'jpww',
  components: {},
  data () {
    return {
      jpwwList: [
        {
          name: '1948年谢士炎烈士所做狱中诗',
          code: 'yzs',
          id: '1573114425412554752'
        },
        {
          name: '1947年卢志英烈士在上海工作时使用的怀表',
          code: 'hb',
          id: '1573114484313165824'
        },
        {
          name: '1928年贺瑞麟在狱中画的五角星',
          code: 'wjx',
          id: '1572901059561656320'
        },
        {
          name: '民国时期赵良璋烈士穿过的皮夹克',
          code: 'pjk',
          id: '1573118574892027904'
        },
        {
          name: '1926年陈君起烈士狱中作水彩画“梅花”',
          code: 'mh',
          id: '1573114327127429120'
        },
        {
          name: '二十世纪三十年代郭纲琳烈士在狱中用铜元磨的鸡心，刻有“永是勇士”',
          code: 'ty',
          id: '1573114492844380160'
        }
      ]
    }
  },
  // 创建元素
  mounted () {},
  // 方法定义
  methods: {
    // 跳转精品文物更多页面
    goMore () {
      // const jpww = this.$router.resolve({
      //   path: '/cultural'
      // })
      // window.open(jpww.href, '_blank')
      const url =
        'http://yhtjyk.travel-yuhuatai.com:9888/YHT/index.html#/Goods'
      window.open(url)
    },

    // 前往文物详情
    goDetail (item) {
      // eslint-disable-next-line no-case-declarations
      const culturalDetail = this.$router.resolve({
        path: '/culturalDetail',
        query: {
          id: item.id
        }
      })
      window.open(culturalDetail.href, '_blank')
    }
  }
}
